/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Form, InputNumber, Button, Select, Input } from "antd";
import { updatePrice, getPrice } from "../../features/price/priceSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
import { useParams } from "react-router-dom";

const { Option } = Select;

const EditPrice = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, updating, message, isUpdateSuccess, price } = useSelector(
    (state) => state.price
  );
  const [form] = Form.useForm();
  const [priceType, setPriceType] = useState(price?.price_type || "stripe");

  const onFinish = (values) => {
    const data = { ...values };
    dispatch(updatePrice({ id, data }));
  };

  useEffect(() => {
    loadPrice();
  }, []);

  useEffect(() => {
    if (price) {
      form.setFieldsValue({
        name: price.name,
        currency: price.currency,
        amount: price.amount,
        credits: price.credits,
        status: price.status?.toString(),
        price_type: price.price_type || "stripe",
        in_app_product_id: price.in_app_product_id || "",
      });
      setPriceType(price.price_type || "stripe");
    }
  }, [price]);

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Hole In One Price is updated successfully",
      });
      navigate("/admin/hole-in-one-price");
    }
  }, [isError, message, isUpdateSuccess, messageApi, navigate]);

  const loadPrice = () => {
    dispatch(getPrice(id));
  };

  const handlePriceTypeChange = (value) => {
    setPriceType(value);
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Shot Price</h3>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Currency"
          name="currency"
          rules={[{ required: true, message: "Please select the currency!" }]}
        >
          <Select>
            <Option value="aud">AUD</Option>
            <Option value="usd">USD</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Price"
          name="amount"
          rules={[{ required: true, message: "Please input the price!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          label="Credit"
          name="credits"
          rules={[{ required: true, message: "Please input the credits!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Price Type"
          name="price_type"
          rules={[{ required: true, message: "Please select the price type!" }]}
        >
          <Select onChange={handlePriceTypeChange}>
            <Option value="stripe">Stripe</Option>
            <Option value="iap">IAP</Option>
          </Select>
        </Form.Item>

        {priceType === "iap" && (
          <Form.Item
            label="In App Product ID"
            name="in_app_product_id"
            rules={[
              { required: true, message: "Please input the in app product id!" },
            ]}
          >
            <Input />
          </Form.Item>
        )}

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={updating}>
            {updating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditPrice;
